<template>
  <div>

    <div id="contact" class="bg-image small"></div>

    <div class="bg-white">
      <div class="container py-3">
        <br class="d-none d-md-block">
        <div class="row">
          <div class="col-lg-12 col-xl-10">
            <h1 class="h2">Questions? Reach out!</h1>
            <p class="lead grey">Our head office is in Copenhagen, and we have branches in Oslo in Norway, Helsingborg in Sweden, Helsinki in Finland, Horsens in Denmark, Hamburg in Germany, Venlo in the Netherlands and Poznań in Poland.</p>
            <hr class="d-none d-md-block">
            <br class="d-none d-md-block">
            <div class="row">
      	      <div class="col-sm-6 col-md-4 mb-4">
                <div class="card">
                  <div class="card-header">
                    PNO Group Office
                  </div>
                  <div class="card-body">
                    <p class="card-text mb-0">Solvej Lee Ørnstrand</p>
                    <p class="card-text small grey">Head of Culture & Communication</p>
                    <p class="card-text small">
                      <i class="far fa-envelope grey mr-2"></i> <a href="mailto:solvej@pnorental.com" class="blue">solvej@pnorental.com</a><br>
                      <i class="far fa-phone grey mr-1"></i> +45 23 28 68 58
                    </p>
                  </div>
                </div>
      	      </div>
      	      <div class="col-sm-6 col-md-4 mb-4">
                <div class="card">
                  <div class="card-header">
                    PNO Sweden
                  </div>
                  <div class="card-body">
                    <p class="card-text mb-0">Rikard Thellnér</p>
                    <p class="card-text small grey">Country Director</p>
                    <p class="card-text small">
                      <i class="far fa-envelope grey mr-2"></i> <a href="mailto:rikard@pnorental.se" class="blue">rikard@pnorental.se</a><br>
                      <i class="far fa-phone grey mr-1"></i> +46(0)760 00 80 10
                    </p>
                  </div>
                </div>
      	      </div>
      	      <div class="col-sm-6 col-md-4 mb-4">
                <div class="card">
                  <div class="card-header">
                    PNO Denmark
                  </div>
                  <div class="card-body">
                    <p class="card-text mb-0">Hanne Johannsen</p>
                    <p class="card-text small grey">Country Director</p>
                    <p class="card-text small">
                      <i class="far fa-envelope grey mr-2"></i> <a href="mailto:hanne@pnorental.dk" class="blue">hanne@pnorental.dk</a><br>
                      <i class="far fa-phone grey mr-1"></i> +45 21 43 25 37
                    </p>
                  </div>
                </div>
      	      </div>
      	      <div class="col-sm-6 col-md-4 mb-4">
                <div class="card">
                  <div class="card-header">
                    PNO Norway
                  </div>
                  <div class="card-body">
                    <p class="card-text mb-0">Kim Laméus</p>
                    <p class="card-text small grey">Country Director</p>
                    <p class="card-text small">
                      <i class="far fa-envelope grey mr-2"></i> <a href="mailto:kim@pnorental.no" class="blue">kim@pnorental.no</a><br>
                      <i class="far fa-phone grey mr-1"></i> +47 955 56 456
                    </p>
                  </div>
                </div>
      	      </div>
      	      <div class="col-sm-6 col-md-4 mb-4">
                <div class="card">
                  <div class="card-header">
                    PNO Finland
                  </div>
                  <div class="card-body">
                    <p class="card-text mb-0">Petteri Heino</p>
                    <p class="card-text small grey">Country Director</p>
                    <p class="card-text small">
                      <i class="far fa-envelope grey mr-2"></i> <a href="mailto:petteri@pnorental.fi" class="blue">petteri@pnorental.fi</a><br>
                      <i class="far fa-phone grey mr-1"></i> +358 400 745 972
                    </p>
                  </div>
                </div>
      	      </div>
      	      <div class="col-sm-6 col-md-4 mb-4">
                <div class="card">
                  <div class="card-header">
                    PNO Netherlands
                  </div>
                  <div class="card-body">
                    <p class="card-text mb-0">Martijn Van Rijswijck</p>
                    <p class="card-text small grey">Country Director &amp; Partner</p>
                    <p class="card-text small">
                      <i class="far fa-envelope grey mr-2"></i> <a href="mailto:martijn@pnorental.nl" class="blue">martijn@pnorental.nl</a><br>
                      <i class="far fa-phone grey mr-1"></i> +31 6 55 913534
                    </p>
                  </div>
                </div>
      	      </div>
              <div class="col-sm-6 col-md-4 mb-4">
                <div class="card">
                  <div class="card-header">
                    PNO Germany
                  </div>
                  <div class="card-body">
                    <p class="card-text mb-0">Wemal Kumar</p>
                    <p class="card-text small grey">Country Director</p>
                    <p class="card-text small">
                      <i class="far fa-envelope grey mr-2"></i> <a href="mailto:wemal@pnorental.de" class="blue">wemal@pnorental.de</a><br>
                      <i class="far fa-phone grey mr-1"></i> +49 40 239596800
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-4 mb-4">
                <div class="card">
                  <div class="card-header">
                    PNO Poland
                  </div>
                  <div class="card-body">
                    <p class="card-text mb-0">Tomasz Milecki</p>
                    <p class="card-text small grey">Country Director</p>
                    <p class="card-text small">
                      <i class="far fa-envelope grey mr-2"></i> <a href="mailto:tomasz@pnorental.pl" class="blue">tomasz@pnorental.pl</a><br>
                      <i class="far fa-phone grey mr-1"></i> +48 604808225
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <br>
          </div>
        </div>

      </div>
    </div>

  	<pno-prompt />

  </div>
</template>

<script>
import PnoPrompt from '@/components/PnoPrompt.vue'

export default {
    mounted() {
        this.$store.commit('meta/title', 'Contact')
        this.$store.commit('meta/title', 'Our head office is in Copenhagen, and we have branches in Oslo and Helsingborg in Sweden, Helsinki in Finland, Horsens in Denmark and Venlo in the Netherlands.')
        this.$store.commit('meta/image', this.generateSmartImgUrl(require('@/assets/img/bg_pno_contact.jpg') , 'ogimage'));
    },
	components: { PnoPrompt },
}
</script>
